import { makeStyles } from '@material-ui/core';
import { KeyboardDatePicker, MuiPickersUtilsProvider } from '@material-ui/pickers';
import { Autocomplete, Grid, TextField, Typography } from '@mui/material';
import React, { useEffect, useState } from 'react';
import DateFnsUtils from '@date-io/date-fns';
import { useSelector } from 'react-redux';
import RMSDictionary from 'components/RMSAutoComplete/RMSDictonary';

const useStyles = makeStyles((theme) => ({
  reportContainer: {
    display: 'flex',
  },
  reportSelection: {
    flex: 0.3,
  },
  reportFilter: {
    flex: 0.7,
  },
  report: {
    paddingBottom: '16px',
  },
  noMargin: {
    margin: '0px !important',
  },
}));

const OffenceChargesBystateReportFilters = (props) => {
  const classes = useStyles();
  const { reportForm, handleReportFormChange, ReportID } = props;
  const formValue = reportForm[ReportID] || {};
  const [ptsStatueArray, setPtsStatueArray] = useState([]);
  const agencySettings = useSelector((state) => state.agencySettings.settings);
  const userAgency = useSelector((state) => state.user.userAgency);
  const ptsStatute = useSelector((state) => state.dictionary.ptsStatute);
  const ptsFBICode = useSelector((state) => state.dictionary.ptsFBICode);

  const legacyExportSetting = agencySettings?.find(
    (item) => item.Path === `${userAgency}.RMS.AllowCitationLegacyExport`
  );
  const isLegacyExportEnable =
    legacyExportSetting && legacyExportSetting?.ValueBoolean === true ? true : false;

  useEffect(() => {
    let sortedArray = ptsStatute
      .filter((s) => s.Description !== '')
      .sort((a, b) => (a.Description > b.Description ? 1 : -1));
    let arr = [];

    sortedArray.forEach((s) => {
      let fbCode = ptsFBICode.find((fb) => fb.ptsFBICodeID === s.ptsFBICodeID)?.FBICode;
      s.FBICode = fbCode;
      arr.push(s);
    });
    if (isLegacyExportEnable) {
      arr = arr.filter((item) => item.StatuteID);
    }

    setPtsStatueArray(arr);
  }, []);

  return (
    <div className={classes.report}>
      <Typography variant="subtitle1" className="py-4">
        {props.title}
      </Typography>
      <Grid container justify="left" alignItems="center" spacing={1}>
        <Grid item xs={6} md={3}>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              disableOpenOnEnter
              autoComplete="off"
              fullWidth
              clearable
              size="small"
              inputVariant="outlined"
              showTodayButton={true}
              variant="dialog"
              format="MM/dd/yyyy"
              id="date-picker-inline-from"
              label="Offense Date From"
              defaultValue={null}
              value={formValue.offenseDateFrom || null}
              onChange={(date) => handleReportFormChange(ReportID, 'offenseDateFrom', date)}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
            />
          </MuiPickersUtilsProvider>
        </Grid>
        <Grid item xs={6} md={3}>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              disableOpenOnEnter
              autoComplete="off"
              fullWidth
              clearable
              size="small"
              inputVariant="outlined"
              showTodayButton={true}
              variant="dialog"
              format="MM/dd/yyyy"
              id="date-picker-inline-from"
              label="Offense Date To"
              defaultValue={null}
              value={formValue.offenseDateTo || null}
              onChange={(date) => handleReportFormChange(ReportID, 'offenseDateTo', date)}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
            />
          </MuiPickersUtilsProvider>
        </Grid>
        <Grid item xs={6} md={3}>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              disableOpenOnEnter
              autoComplete="off"
              fullWidth
              clearable
              size="small"
              inputVariant="outlined"
              showTodayButton={true}
              variant="dialog"
              format="MM/dd/yyyy"
              id="date-picker-inline-from"
              label="Arrest From"
              defaultValue={null}
              value={formValue.arrestDateFrom || null}
              onChange={(date) => handleReportFormChange(ReportID, 'arrestDateFrom', date)}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
            />
          </MuiPickersUtilsProvider>
        </Grid>
        <Grid item xs={6} md={3}>
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              disableOpenOnEnter
              autoComplete="off"
              fullWidth
              clearable
              size="small"
              inputVariant="outlined"
              showTodayButton={true}
              variant="dialog"
              format="MM/dd/yyyy"
              id="date-picker-inline-from"
              label="Arrest To"
              defaultValue={null}
              value={formValue.arrestDateTo || null}
              onChange={(date) => handleReportFormChange(ReportID, 'arrestDateTo', date)}
              KeyboardButtonProps={{
                'aria-label': 'change date',
              }}
            />
          </MuiPickersUtilsProvider>
        </Grid>
        <Grid item xs={8}>
          <RMSDictionary
            options="codeLocationCategories"
            multiple={true}
            value={formValue.locationCategories || []}
            className={classes.noMargin}
            label="Location Categories"
            compact
            onChange={(ev, newVal) => {
              handleReportFormChange(ReportID, 'locationCategories', newVal);
            }}
          />
        </Grid>

        <Grid item xs={4}>
          <RMSDictionary
            options="codeZones"
            multiple={true}
            value={formValue.zones || []}
            className={classes.noMargin}
            label="Zones"
            compact
            onChange={(ev, newVal) => {
              handleReportFormChange(ReportID, 'zones', newVal);
            }}
          />
        </Grid>

        <Grid item xs={8}>
          <Autocomplete
            multiple
            size="small"
            autoComplete
            autoSelect={false}
            autoHighlight
            getOptionLabel={(option) => {
              return `${option.Description} | ${option.Code} | ${option.FBICode}`;
            }}
            options={ptsStatueArray}
            key={formValue?.offenses || ''}
            value={formValue?.offenses || []}
            onChange={(event, newValue) => {
              handleReportFormChange(ReportID, 'offenses', newValue);
            }}
            renderInput={(params) => (
              <TextField
                autoComplete="off"
                size="small"
                {...params}
                label="Search offense"
                sx={{
                  '& .MuiOutlinedInput-root': {
                    borderRadius: '0.5rem',
                  },
                }}
                variant="outlined"
                fullWidth
              />
            )}
          />
        </Grid>

        <Grid item xs={4}>
          <RMSDictionary
            options="codeStates"
            multiple={true}
            value={formValue.offenderHomeStates || []}
            className={classes.noMargin}
            label="Offender Home State"
            compact
            onChange={(ev, newVal) => {
              handleReportFormChange(ReportID, 'offenderHomeStates', newVal);
            }}
          />
        </Grid>
      </Grid>
    </div>
  );
};

export default OffenceChargesBystateReportFilters;
